import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Pinterest: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={size ?? '21'}
      height={size ?? '21'}
      fill="none"
      viewBox="0 0 21 21"
      data-testid="pinterest-icon"
    >
      <g clipPath="url(#aba)" transform="matrix(.08607 0 0 -.08607 -.09 21.259)">
        <path
          style={{
            fill: color ? 'transparent' : '#fff',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
            strokeWidth: 1.25,
          }}
          transform="matrix(.8 0 0 -.8 0 250)"
          d="M153.803 3.76C69.585 3.76 1.313 72.03 1.313 156.25c0 84.218 68.272 152.49 152.49 152.49 84.217 0 152.49-68.273 152.49-152.49 0-84.219-68.273-152.49-152.49-152.49z"
        />
        <path
          fill={color ?? '#e60023'}
          style={{
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
            strokeWidth: 1.25,
          }}
          d="M153.803 3.76c-84.218 0-152.49 68.273-152.49 152.49 0 64.603 40.194 119.828 96.92 142.047-1.333-12.065-2.54-30.62.527-43.791 2.771-11.901 17.88-75.797 17.88-75.797s-4.56-9.136-4.56-22.64c0-21.204 12.29-37.034 27.592-37.034 13.01 0 19.295 9.768 19.295 21.48 0 13.084-8.33 32.645-12.63 50.772-3.592 15.178 7.613 27.555 22.583 27.555 27.102 0 47.935-28.577 47.935-69.828 0-36.512-26.236-62.04-63.697-62.04-43.389 0-68.855 32.544-68.855 66.176 0 13.107 5.05 27.161 11.35 34.801 1.246 1.51 1.427 2.832 1.056 4.373-1.158 4.816-3.73 15.175-4.234 17.295-.665 2.791-2.212 3.384-5.102 2.04-19.045-8.866-30.951-36.712-30.951-59.077 0-48.102 34.95-92.28 100.756-92.28 52.898 0 94.008 37.697 94.008 88.073 0 52.554-33.137 94.848-79.13 94.848-15.452 0-29.978-8.028-34.95-17.51 0 0-7.647 29.115-9.5 36.25-3.443 13.245-12.737 29.848-18.954 39.976 14.268 4.418 29.43 6.801 45.15 6.801 84.22 0 152.493-68.273 152.493-152.49 0-84.218-68.274-152.49-152.492-152.49z"
          transform="matrix(.8 0 0 -.8 0 250)"
        />
      </g>
    </svg>
  );
};

export default Pinterest;
